import { render, staticRenderFns } from "./points_recharge.vue?vue&type=template&id=061f2295&scoped=true"
import script from "./points_recharge.vue?vue&type=script&lang=js"
export * from "./points_recharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061f2295",
  null
  
)

export default component.exports